import { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CommonNavBar from "views/components/CommonNavBar";
import { Toast } from "react-vant";
import styles from "./PointsMall.module.less";
import { getGoodsList, getCouponGoodsList } from "api/points";
import useScrollLoad from "utils/useScrollLoad";
import { getIntegralList } from "api/points";

const loadingText = {
  nomore: "已经到底啦～",
  loading: "正在加载～",
  empty: "暂无数据",
};
function PointsMall() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const coupon_id = params.get("coupon_id");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const pointLoadingRef = useRef(null);
  const [integral, setIntegral] = useState();
  const initData = async () => {
    const getListRequest = coupon_id ? getCouponGoodsList : getGoodsList;
    pointLoadingRef.current = Toast.loading({
      message: "正在加载数据...",
      forbidClick: true,
      duration: 0,
    });
    setLoading(true);
    const res = await getListRequest(currentPage, coupon_id);
    const inteRes = await getIntegralList();
    pointLoadingRef.current.clear();
    setLoading(false);
    if (res.code === 200) {
      setCurrentPage(currentPage + 1);
      setTotalCount(res.data.total_count);
      if (Array.isArray(res.data?.data) && res.data.data.length > 0) {
        setDataList([...dataList, ...res.data.data]);
      } else {
        setTotalCount(0);
      }
    }
    if (inteRes.code === 200) {
      setIntegral(inteRes.data?.integral?.integral);
    }
  };
  const containerRef = useScrollLoad(() => {
    if (dataList.length < totalCount && !loading) {
      initData();
    }
  });
  useEffect(() => {
    initData();
  }, []);
  return (
    <div className={styles["points-mall-container"]}>
      <CommonNavBar
        isTop
        onClickBack={() => {
          navigate(-1);
        }}
        backgroundColor={"transparent"}
      />
      <div className={styles["mall-list-container"]} ref={containerRef}>
        <div className={styles["mall-header"]}>
          <div className={styles["mall-header-content"]}>
            <div className={styles["content-title"]}>{integral || 0}</div>
            <div className={styles["content-text"]}>我的积分</div>
          </div>
          <img
            className={styles["mall-header-icon"]}
            src={require("@/images/mine/img_integration_store_bg.png")}
          />
        </div>
        <div className={styles["mall-list"]}>
          {dataList.map((item, index) => (
            <div
              className={styles["mall-list-item"]}
              key={`points-mall-${index}`}
              onClick={() => {
                navigate(
                  `/mine/goodsDetail?integral=${integral}&id=${item.goods_id}${
                    coupon_id ? `&coupon_id=${coupon_id}` : ""
                  }`
                );
              }}
            >
              <img className={styles["item-pic"]} src={item.thumb} />
              <div className={styles["item-text"]}>{item.goods_name}</div>
              <div className={styles["item-bottom"]}>
                <div
                  className={styles["item-bottom-integral"]}
                >{`${item.integral}积分`}</div>
                {item.coupon_count > 0 ? (
                  <div
                    className={styles["item-bottom-coupon"]}
                  >{`${item.coupon_count}张可用礼券`}</div>
                ) : null}
              </div>
            </div>
          ))}
          <div className={styles["mall-list-bottom"]}>
            {loading
              ? loadingText["loading"]
              : dataList.length === 0
              ? loadingText["empty"]
              : loadingText["nomore"]}
          </div>
        </div>
      </div>
    </div>
  );
}
export default PointsMall;
